module.exports = __webpack_public_path__ + "static/media/aven-prairie-smoke.dd45af04.jpg";